import {
	requestAvatars,
	requestSettings,
	requestUserAchievements,
	showErrorModal,
} from "modules/actions";
import {isLoggedIn} from "modules/selectors";
import {all, put, select} from "typed-redux-saga";
import {ApiError} from "modules/utils";

export const requestLandingDataSaga = function* () {
	try {
		const isLogged = yield* select(isLoggedIn);

		const requestsActions = [];

		requestsActions.push(requestSettings());

		if (isLogged) {
			requestsActions.push(requestAvatars());
			requestsActions.push(requestUserAchievements());
		}

		yield* all(requestsActions.map((action) => put(action)));
	} catch (err) {
		const {message} = err as ApiError;
		yield* put(showErrorModal({message}));
	}
};
